var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_vm._v(" "),_c('div',{staticClass:"personalServices"},[_c('Nav'),_vm._v(" "),_c('LoginForm',{attrs:{"title":"用人单位服务","pics":['/static/employerServices1.png'],"description":"中华人民共和国境内的任何合法经营企业，均可申请并经平台查证后，获得溯源优才平台的合作企业认定，平台提供基础管理工具，也提供相关业务的订制化增信服务。"}})],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-329299fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/employerServices/index.vue
// module id = null
// module chunks = 